<script>
  export let defaultImageUrl;
  export let apiUrl;
  let selectedRegion = "";

  const selectARegionEl = document.querySelector(
    '[name="fields[nearestBranch]"]'
  );

  const decodeHtml = (html) => {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  selectARegionEl.addEventListener("change", (e) => {
    selectedRegion = e.target.value;
  });

  const formHeaderTextEl = document.querySelector(".lp-form-header-text > h3");

  $: formHeaderTextEl.textContent =
    selectedRegion !== ""
      ? `Contact the\r\n${
          selectARegionEl.options[selectARegionEl.selectedIndex].text
        } branch`
      : ``;

  const getBranchManagerDetails = async (regionId) => {
    return fetch(`${apiUrl}/${regionId}`)
      .then((res) => res.text())
      .then((res) => {
        return JSON.parse(decodeHtml(res));
      });
  };
</script>

{#if selectedRegion === ""}
  <img src={defaultImageUrl} />
{:else}
  {#await getBranchManagerDetails(selectedRegion) then value}
    <svg viewBox="0 0 140 159" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M140 0H10C4.47716 0 0 4.47715 0 10V158.662C33.7458 98.2766 83.4703 43.4686 140 0.3683V0Z"
        fill="#0A5F9D"
      />
    </svg>
    <div class="branch-manager-details-container">
      <div class="branch-manager-photo">
        <img src={value.photoUrl} />
      </div>
      <div class="branch-manager-name-phone-email">
        <p class="title is-5">{value.name}</p>
        <p class="">Branch Manager</p>
        {#if !!value.phone}
          <a href="tel:{value.phone.replaceAll(/\s/g, '')}">{value.phone} </a>
        {/if}
        <a href="mailto:{value.email}">{value.email}</a>
      </div>
    </div>
  {/await}
{/if}
